module.exports = __webpack_public_path__ + "img/nodeType5.ec442848.svg";